import { Pipe, PipeTransform } from '@angular/core';
import {Util} from '../../core/tool';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {

  transform(value: number, decimal: number = null): unknown {
    return Util.numberFormat(value, decimal);
  }

}
